<template>
<div class="chapter">
<div class="inner_page">
<div id="df42f5abd977e-d1e239"><span id="pageiii">
<h1 class="book-title">LOUISE’S CHANCE</h1>
<h2 class="book-author">Sarah R. Shaber</h2>
<p class="publisher-logo"><span class="image-centered" id="imgd1e955"><img alt="" src="OEBPS/images/9781780107158_epub_002.jpg"/></span></p><span id="pageiv">
<p class="publisher-logo"></p></span></span></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781780107158_epub_tp.vue?35ff6daa